import React, { useState } from 'react'
import FormLayoutTwo from '../../../../Core/Layout/FormLayoutTwo'
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button.jsx";
import GetIcon from "../../../../utils/Icon.jsx";

const PeriodClosingVoucherDetailsList = () => {
    const [tab, settab] = useState(1);
    const [res, setRes] = useState(false);
    const [error, setError] = useState("");
    const [errors, setErrors] = useState({});
    const [ptype, setptype] = useState("Error");
  
  
    return (
         <FormLayoutTwo
        title="Period Closing Voucher Detail "
        breadcrumbs={[
  
          {
            label: "Period-Closing-Voucher-List",
            url: "Period-Closing-Voucher-List/Period Closing Voucher Detail",
          },
        ]}
        
        actionButtons={
          <>
            <Button
              className="custom-btn-FF8D5C px-2 rounded-1"
              // iconName="LuFilePlus2"
              style={{ gap: "2px", height: "28px" , backgroundColor:"#FF8D5C" , color :"#FFFFFF" }}
             
              iconSize={12}
            >
              Ledger
            </Button>
            <Button
              className="custom-btn-00989 rounded-1"
              iconName="LuFilePlus2"
              style={{ gap: "2px", height: "28px" , color :"#FFFFFF" }}
             
              iconSize={12}
            >
              Save
            </Button>

            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: "21px" }}
            />
          </>
        }
      >
           <div
                  className=""
                  style={{ width: "100%",  backgroundColor: "#fff" }}
                >
                  
                  <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
                    <div className="d-flex justify-content-between align-items-end ">
                      <ul
                        className="nav nav-tabs"
                        style={{ color: "white", border: "none" }}
                      >
                        <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                          <a
                            className={
                              tab === 1
                                ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                                : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                            }
                            onClick={() => settab(1)}
                            href="javascript:void(0);"
                          >
                            General Details{" "}
                            {tab === 1 ? (
                              <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                            ) : (
                              <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                            )}
                          </a>
                        </li>
                      </ul>
                      <div
                        className="d-flex align-items-center mb-2 px-3"
                        style={{ gap: "2px", fontSize: "12px" }}
                      >
                        <span style={{ position: "relative", top: "-1px" }}>
                          <GetIcon
                            className="text-[#4B002B]"
                            iconName="CgAttachment"
                            size={12}
                          />
                        </span>
                        <span className="fw-semibold" style={{ color: "#4B002B" }}>
                          Attachments
                        </span>
                      </div>
                    </div>
                  </div>
            <div className=" conatainer p-3 bg-white ">
              <div className="row g-4 bg-white">
             {/* LEFT CARD */}
                 <div className="col-md-6">
                  <div
                   style={{
                   backgroundColor: "#F6F4FF",
                   borderRadius: "6px",
                   padding: "16px",
                   height: "100%",
                 }}
               >
                 <div className="row mb-2">
                   <div className="col-6">
                     <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                       Series
                     </div>
                     <div style={{ fontWeight: 600, color: "#6f42c1" }}>
                       ACC-PCV-2025-00001
                     </div>
                   </div>
       
                   <div className="col-6">
                     <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                       Transaction Date
                     </div>
                     <div style={{ fontWeight: 600 }}>24-11-2025</div>
                   </div>
                 </div>
       
                 <div className="row">
                   <div className="col-6">
                     <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                       Closing Account Head
                     </div>
                     <div style={{ fontWeight: 600 }}>Creditors - LND</div>
                   </div>
       
                   <div className="col-6">
                     <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                       Company
                     </div>
                     <div style={{ fontWeight: 600, color: "#f59e0b" }}>
                       Lakshmi Narain Diamond (India) Pvt. Ltd.
                     </div>
                   </div>
                 </div>
               </div>
             </div>
         
               {/* RIGHT CARD */}
               <div className="col-md-6">
                 <div
                   style={{
                     backgroundColor: "#E9F8E4",
                     borderRadius: "6px",
                     padding: "16px",
                     height: "100%",
                   }}
                 >
                   <div className="row mb-2">
                     <div className="col-4">
                       <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                         Fiscal Year
                       </div>
                       <div style={{ fontWeight: 600 }}>2024-2025</div>
                     </div>
         
                     <div className="col-4">
                       <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                         Period Start Date
                       </div>
                       <div style={{ fontWeight: 600 }}>01-04-2024</div>
                     </div>
         
                     <div className="col-4">
                       <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                         Period End Date
                       </div>
                       <div style={{ fontWeight: 600 }}>31-03-2025</div>
                     </div>
                   </div>
         
                   <div className="row">
                     <div className="col-8">
                       <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                         Remarks
                       </div>
                       <div style={{ fontSize: "0.85rem" }}>
                         Lorem ipsum dolor sit amet consectetur.
                         <br />
                         Ac mi ut elementum dolor.
                       </div>
                     </div>
         
                     <div className="col-4">
                       <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                         GL Entry Processing Status
                       </div>
                       <div style={{ fontWeight: 600 }}>In Progress</div>
                     </div>
                   </div>
                 </div>
               </div>
                 </div>
                 </div>
          </div>
    </FormLayoutTwo>
  )
}

export default PeriodClosingVoucherDetailsList